import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  requestGenerateUrl({ commit }, data) {
    commit(types.GENERATE_URL_REQUEST);

    const urls = {
      favourites: {
        json: 'construct/interactions/campaign_feed/',
        rss: 'construct/interactions/campaign_rssfeed/',
      },
      onair: {
        json: 'construct/interactions/onair_feed/',
        rss: 'construct/interactions/onair_rssfeed/',
      },
    };

    const generatedOption = data.isGenerateForOnAir ? 'onair' : 'favourites';
    const generatedType = data.isResponseTypeRSS ? 'rss' : 'json';
    const url = `interactions/token/?id=${data.selectedId}`;

    colonyAPI
      .get(url)
      .then(response => {
        const generatedurl = `${colonyAPI.defaults.baseURL}${urls[generatedOption][generatedType]}${response.data.access_token}/`;
        commit(types.GENERATE_URL_SUCCESS, generatedurl);
      }).catch(error => commit(types.GENERATE_URL_FAILED, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/publishing/actions.js